<template>
  <div class="container mt-5">
    <h2>File Upload</h2>

    <!-- Поле для ввода токена -->
    <div class="mb-3">
      <label for="token" class="form-label">Enter Token:</label>
      <input type="text" v-model="adminToken" class="form-control" placeholder="Enter your token" />
      <div v-if="tokenError" class="alert alert-danger mt-2">{{ tokenError }}</div>
    </div>

    <div class="mb-3">
      <label for="file" class="form-label">Choose a file:</label>
      <input type="file" class="form-control" @change="onFileChange" />
      <div v-if="fileError" class="alert alert-danger mt-2">{{ fileError }}</div>
    </div>

    <div class="form-check mb-3">
      <input type="checkbox" class="form-check-input" v-model="isOneTimeFile" id="oneTimeFile" />
      <label class="form-check-label" for="oneTimeFile">One-time file</label>
    </div>

    <div v-if="!isOneTimeFile" class="mb-3">
      <label for="expiration" class="form-label">Storage period:</label>
      <select class="form-select" v-model="expirationPeriod">
        <option value="1">1 day</option>
        <option value="2">1 week</option>
        <option value="3">1 month</option>
      </select>
    </div>

    <button @click="authenticateAndUpload" class="btn btn-primary" :disabled="fileError || !file || isLoading">
      Upload
      <span v-if="isLoading" class="spinner-border spinner-border-sm ms-2" role="status" aria-hidden="true"></span>
    </button>

    <!-- Показываем результат только если есть данные о ссылке и токене -->
    <div v-if="uploadResult" class="mt-5">
      <div class="card p-3">
        <h5 class="card-title">Download Link</h5>
        <p class="card-text">
          <span class="copy-box" @click="copyToClipboard(uploadResult.downloadFileUrl, 'linkTooltip')" data-bs-toggle="tooltip" title="Click to copy">
            {{ uploadResult.downloadFileUrl }}
          </span>
          <span id="linkTooltip" class="tooltip-text">Copied!</span>
        </p>
      </div>

      <div class="card p-3 mt-3">
        <h5 class="card-title">Folder Token</h5>
        <p class="card-text">
          <span class="copy-box" @click="copyToClipboard(uploadResult.folderToken, 'tokenTooltip')" data-bs-toggle="tooltip" title="Click to copy">
            {{ uploadResult.folderToken }}
          </span>
          <span id="tokenTooltip" class="tooltip-text">Copied!</span>
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import { apiUrl } from '../axiosRequest.js';
import { loadConfig } from '../axiosRequest.js';
import { mapActions, mapGetters } from 'vuex';

let axiosInstance = null;

async function getAxiosInstance() {
  if (!axiosInstance) {
    axiosInstance = await loadConfig();
  }
  return axiosInstance;
}

export default {
  data() {
    return {
      adminToken: '', // Токен пользователя
      tokenError: null, // Ошибка для токена
      file: null,
      fileError: null,
      isOneTimeFile: false,
      expirationPeriod: 1,
      isLoading: false,
    };
  },
  computed: {
    ...mapGetters(['getFileUploadResult']),
    uploadResult() {
      return this.getFileUploadResult;
    }
  },
  methods: {
    ...mapActions(['saveFileUploadResult']),
    async authenticateAndUpload() {
      if (!this.adminToken) {
        this.tokenError = 'Token is required.';
        return;
      }

      this.tokenError = null;
      this.isLoading = true;

      try {
        const axios = await getAxiosInstance();
        const response = await axios.get(`/tokens/Authenticate`, {
          params: { AdminHash: this.adminToken }
        });

        if (!response.data.success) {
          this.tokenError = 'Invalid token.';
          this.isLoading = false;
          return;
        }

        // Если аутентификация прошла успешно, загружаем файл
        this.uploadFile();
      } catch (error) {
        console.error('Error authenticating token:', error);
        this.tokenError = 'Error authenticating token.';
        this.isLoading = false;
      }
    },
    onFileChange(e) {
      this.file = e.target.files[0];
      if (this.file && this.file.size > 50 * 1024 * 1024) {
        this.fileError = 'File size exceeds 50 MB.';
        this.file = null;
      } else {
        this.fileError = null;
      }
    },
    async uploadFile() {
      if (!this.file) {
        alert('Please choose a file');
        return;
      }

      const formData = new FormData();
      formData.append('file', this.file);

      const expirationType = this.isOneTimeFile ? 0 : this.expirationPeriod;

      try {
        const axios = await getAxiosInstance();
        const response = await axios.post(`/files/Upload?expirationType=${expirationType}`, formData, {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        });

        const { downloadFileUrl, folderToken } = response.data;
        const downloadLink = `${apiUrl}api/files/Download/${downloadFileUrl}`;

        this.saveFileUploadResult({
          downloadFileUrl: downloadLink,
          folderToken: folderToken
        });

        this.isLoading = false;
      } catch (error) {
        console.error('Error uploading file:', error);
        this.isLoading = false;
        alert('Error uploading file');
      }
    },
    copyToClipboard(text, tooltipId) {
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(text).then(() => {
          const tooltip = document.getElementById(tooltipId);
          tooltip.style.visibility = 'visible';
          setTimeout(() => {
            tooltip.style.visibility = 'hidden';
          }, 1500);
        }).catch(err => {
          console.error('Failed to copy: ', err);
        });
      } else {
        const textarea = document.createElement('textarea');
        textarea.value = text;
        document.body.appendChild(textarea);
        textarea.select();
        try {
          document.execCommand('copy');
          const tooltip = document.getElementById(tooltipId);
          tooltip.style.visibility = 'visible';
          setTimeout(() => {
            tooltip.style.visibility = 'hidden';
          }, 1500);
        } catch (err) {
          console.error('Fallback: Oops, unable to copy', err);
        }
        document.body.removeChild(textarea);
      }
    }
  }
};
</script>



<style scoped>
.copy-box {
  display: inline-block;
  padding: 10px;
  border: 1px solid #ccc;
  border-radius: 5px;
  cursor: pointer;
  background-color: #f9f9f9;
  max-width: 100%; 
  color: black;
  text-decoration: none;
  user-select: none;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.copy-box:hover {
  background-color: #e9e9e9;
}

.tooltip-text {
  visibility: hidden;
  background-color: black;
  color: white;
  text-align: center;
  border-radius: 5px;
  padding: 5px;
  position: absolute;
  z-index: 1;
  margin-left: 10px;
  font-size: 12px;
}

/* Стиль для иконки загрузки */
.spinner-border {
  display: inline-block;
  width: 1rem;
  height: 1rem;
  border: 0.15em solid currentColor;
  border-right-color: transparent;
  border-radius: 50%;
  animation: spinner-border .75s linear infinite;
}

@keyframes spinner-border {
  to {
    transform: rotate(360deg);
  }
}
</style>
